import { Theme } from '@mui/material';

/**
 * Dezenter Scrollbalken (Auftrag Alex 22.07., N3) — dasselbe Aussehen, das der
 * Kalender seit `824dcf22` lokal hat, jetzt als benannter Baustein.
 *
 * Angewendet auf den Scroll-Container der Seiten-Shell
 * (`views/home/index.tsx`), der auf JEDER Seite den Standardbalken ueber die
 * volle Fensterhoehe zeigte und deshalb wie der Balken des Browsers aussah.
 *
 * NUR AUSSEHEN: kein `overflow`, keine Hoehe, kein `scroll-behavior`. Ein
 * zentraler Baustein, der Verhalten mitbraechte, wuerde jede Seite still
 * veraendern — gepinnt durch `scrollbar.test.ts` („fasst das Scroll-VERHALTEN
 * nicht an").
 *
 * ZWEI WEGE NOETIG, keiner deckt alle Browser ab: Firefox versteht nur die
 * Standard-Properties (`scrollbar-width`/`scrollbar-color`), WebKit/Blink nur
 * die `::-webkit-scrollbar`-Pseudo-Elemente.
 *
 * AUTO-HIDE, soweit CSS es hergibt — und das ist die Grenze: es gibt **keinen
 * Selektor fuer „scrollt gerade"**. CSS kann nur auf `:hover` reagieren, nicht
 * auf Scroll-Aktivitaet. Das Verhalten ist damit „unsichtbar in Ruhe, sichtbar
 * bei Zeigerkontakt" — nicht das Einblenden-und-Verblassen, das macOS und
 * mobile Systeme von sich aus machen. Auf Systemen mit dauerhaft sichtbaren
 * Balken (Windows/Linux-Standard) ist das eine echte Aenderung: ohne Zeiger
 * verraet der Balken nicht mehr, dass es weitergeht. Bewusst so entschieden
 * (Auftrag „Auto-Hide"); umkehrbar, indem die Ruhefarbe von `transparent` auf
 * `divider` gesetzt wird.
 *
 * Alle Farben kommen aus dem Theme (CLAUDE.md §5: keine Hex-Werte). Der Test
 * beweist das, indem er ein zweites Theme durchschickt und andere Werte
 * erwartet.
 */
export const subtleScrollbar = (theme: Theme) => ({
  scrollbarWidth: 'thin',
  // Firefox: Thumb in Ruhe unsichtbar, die Spur dauerhaft.
  scrollbarColor: 'transparent transparent',
  '&:hover': {
    scrollbarColor: `${theme.palette.divider} transparent`,
  },
  // WebKit/Blink. `height` deckt waagerechte Balken mit ab, damit der
  // Baustein auch an einem quer scrollenden Container stimmt.
  '&::-webkit-scrollbar': { width: 8, height: 8 },
  '&::-webkit-scrollbar-track': { backgroundColor: 'transparent' },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: 4,
    backgroundColor: 'transparent',
  },
  '&:hover::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.divider,
    '&:hover': { backgroundColor: theme.palette.action.disabled },
  },
});

export default subtleScrollbar;
